import type { Consent, Privacy } from '@tunein/reporting-schemas';

export type ConsentStatus = Consent['status'];
export type SystemAdTrackingStatus = Privacy['systemAdTrackingStatus'];

// `satisfies Record<Status, Status>` on both maps makes the reporting schema the source of truth:
// a status added to or removed from the proto fails to compile here rather than silently going
// unreported.
export const consentStatuses = {
  CONSENT_STATUS_UNSPECIFIED: 'CONSENT_STATUS_UNSPECIFIED',
  CONSENT_STATUS_GRANTED: 'CONSENT_STATUS_GRANTED',
  CONSENT_STATUS_DENIED: 'CONSENT_STATUS_DENIED',
} as const satisfies Record<ConsentStatus, ConsentStatus>;

export const systemAdTrackingStatuses = {
  SYSTEM_AD_TRACKING_STATUS_UNSPECIFIED: 'SYSTEM_AD_TRACKING_STATUS_UNSPECIFIED',
  SYSTEM_AD_TRACKING_STATUS_RESTRICTED: 'SYSTEM_AD_TRACKING_STATUS_RESTRICTED',
  SYSTEM_AD_TRACKING_STATUS_DENIED: 'SYSTEM_AD_TRACKING_STATUS_DENIED',
  SYSTEM_AD_TRACKING_STATUS_AUTHORIZED: 'SYSTEM_AD_TRACKING_STATUS_AUTHORIZED',
} as const satisfies Record<SystemAdTrackingStatus, SystemAdTrackingStatus>;

// The US Privacy string is four characters: version, notice given, opted out of sale, LSPA.
// https://github.com/InteractiveAdvertisingBureau/USPrivacy/blob/master/CCPA/US%20Privacy%20String.md
export const US_PRIVACY_OPT_OUT_INDEX = 2;
